//Fetch reports
export const FETCHING_REPORTS = 'scheduling-reports/FETCHING_REPORTS';
export const FETCH_REPORTS = 'scheduling-reports/FETCH_REPORTS';
export const FETCH_REPORTS_SUCCESS = 'scheduling-reports/FETCH_REPORTS_SUCCESS';

//Fetch report fields
export const FETCHING_REPORT_FIELDS =
  'scheduling-reports/FETCHING_REPORT_FIELDS';
export const FETCH_REPORT_FIELDS = 'scheduling-reports/FETCH_REPORT_FIELDS';
export const FETCH_REPORT_FIELDS_SUCCESS =
  'scheduling-reports/FETCH_REPORT_FIELDS_SUCCESS';

export const SET_SELECTED_FIELDS = 'scheduling-reports/SET_SELECTED_FIELDS';
export const SET_FILTERS = 'scheduling-reports/SET_FILTERS';
export const SET_REPORT_FILTERS = 'scheduling-reports/SET_REPORT_FILTERS';
export const SET_SCHEDULE = 'scheduling-reports/SET_SCHEDULE';
export const SET_RECIPIENTS = 'scheduling-reports/SET_RECIPIENTS';
export const SET_DETAILS = 'scheduling-reports/SET_DETAILS';

export const SET_BUSINESS_REPORT = 'scheduling-reports/SET_BUSINESS_REPORT';
export const SET_USER_REPORT = 'scheduling-reports/SET_USER_REPORT';

export const SAVE_REPORT = 'scheduling-reports/SAVE_REPORT';
export const SAVING_REPORT = 'scheduling-reports/SAVING_REPORT';
export const SAVE_REPORT_SUCCESS = 'scheduling-reports/SAVE_REPORT_SUCCESS';
export const SAVE_REPORT_FAILED = 'scheduling-reports/SAVE_REPORT_FAILED';
export const SET_COUNTRY = 'scheduling-reports/SET_COUNTRY';
export const SET_COSTCENTER = 'scheduling-reports/SET_COSTCENTER';
export const RESET_RESTRICTIONS =
  'scheduling-reports/RESET_RESTRICTIONS';
export const SET_RESTRICTIONS = 'scheduling-reports/SET_RESTRICTIONS';

export const CHANGE_SCHEDULE = 'scheduling-reports/CHANGE_SCHEDULE';

export const CLONE_REPORT = 'scheduling-reports/CLONE_REPORT';

export const DELETE_REPORT = 'scheduling-reports/DELETE_REPORT';
export const DELETING_REPORT = 'scheduling-reports/DELETING_REPORT';
export const DELETE_REPORT_SUCCESS = 'scheduling-reports/DELETE_REPORT_SUCCESS';
export const DELETE_REPORT_FAILED = 'scheduling-reports/DELETE_REPORT_FAILED';

export const EXPORT_REPORT = 'scheduling-reports/EXPORT_REPORT';
export const EXPORTING_REPORT = 'scheduling-reports/EXPORTING_REPORT';
export const EXPORT_REPORT_SUCCESS = 'scheduling-reports/EXPORT_REPORT_SUCCESS';
export const EXPORT_REPORT_FAILED = 'scheduling-reports/EXPORT_REPORT_FAILED';

export const EXPORT_CUSTOMISED_REPORT =
  'scheduling-reports/EXPORT_CUSTOMISED_REPORT';
export const EXPORTING_CUSTOMISED_REPORT =
  'scheduling-reports/EXPORTING_CUSTOMISED_REPORT';
export const EXPORT_CUSTOMISED_REPORT_SUCCESS =
  'scheduling-reports/EXPORT_CUSTOMISED_REPORT_SUCCESS';
export const EXPORT_CUSTOMISED_REPORT_FAILED =
  'scheduling-reports/EXPORT_CUSTOMISED_REPORT_FAILED';

export type Action =
  | { type: FETCHING_REPORTS }
  | { type: FETCH_REPORTS, data: Array<Object> }
  | { type: FETCH_REPORTS_SUCCESS, data: Array<Object> }
  | { type: FETCHING_REPORT_FIELDS }
  | { type: FETCH_REPORT_FIELDS, data: Array<Object> }
  | { type: FETCH_REPORT_FIELDS_SUCCESS, data: Array<Object> }
  | { type: SET_SELECTED_FIELDS, data: Array<Object> }
  | { type: SET_FILTERS, data: Array<Object> }
  | { type: SET_REPORT_FILTERS, data: Array<Object> }
  | { type: SET_RECIPIENTS, data: Object }
  | { type: SET_SCHEDULE, data: Object }
  | { type: EXPORTING_REPORT }
  | { type: EXPORT_REPORT_SUCCESS }
  | { type: EXPORT_REPORT_FAILED }
  | { type: EXPORTING_CUSTOMISED_REPORT }
  | { type: EXPORT_CUSTOMISED_REPORT_SUCCESS }
  | { type: EXPORT_CUSTOMISED_REPORT_FAILED }
  | { type: SAVE_REPORT, data: Object }
  | { type: SAVE_REPORT_SUCCESS }
  | { type: SAVE_REPORT_FAILED }
  | { type: SAVING_REPORT }
  | { type: CLONE_REPORT }
  | { type: DELETE_REPORT }
  | { type: DELETING_REPORT }
  | { type: DELETE_REPORT_SUCCESS }
  | { type: DELETE_REPORT_FAILED }
  | { type: CHANGE_SCHEDULE }
  | { type: SET_COUNTRY, data: Object }
  | { type: SET_COSTCENTER, data: Object };



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/action-types.js